import { PLAN_API_ENDPOINTS } from "@/features/auth/config/planApiPath";
import type { Plan, PlanResponse } from "@/features/auth/types/plan.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getPlan = async (organizationId: string, accessToken: string): Promise<Plan> => {
  const response = await fetcher.get<PlanResponse>(
    PLAN_API_ENDPOINTS.GET_PLAN(organizationId),
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );

  return response.data.plan;
};
